// Routes for uploading an old claim and checking it before it is saved.
import React from "react";

const ClaimImportsIndex = React.lazy(() => import("./index"));
const NewClaimImport = React.lazy(() => import("./new"));
const ClaimImportShow = React.lazy(() => import("./show"));

export default [
  { path: "/administration/claim_imports/new", component: NewClaimImport, name: "Import claims" },
  { path: "/administration/claim_imports/:id", component: ClaimImportShow, name: "Imported claim" },
  { path: "/administration/claim_imports", exact: true, component: ClaimImportsIndex, name: "Import claims" },
];
